import { Component, Injector, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { AppConsts } from '@shared/AppConsts';
import { AppComponentBase } from '@shared/common/app-component-base';
import { EpisodeDto, EpisodeOvalsServiceProxy, OvalFilesDto } from '@shared/service-proxies/service-proxies';
import { map, shareReplay, switchMap, take, tap } from 'rxjs/operators';
import { Language, LanguageData } from '../language-picker-local/LanguageConsts';
import { BehaviorSubject } from 'rxjs';


@Component({
    templateUrl: './oval-content.component.html',
    styleUrls: ['./oval-content.component.less'],
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()],
    selector: 'oval-content',
})
export class OvalContentComponent extends AppComponentBase {

    episodes: EpisodeDto[] = [];
    languages: Language[] = LanguageData.languages;
    currentEpisodeId = localStorage.getItem("currentEpisode");
    episodeOvalId: number;
    color = "";
    selectedTemplate: number;

    constructor(
        injector: Injector,
        private route: ActivatedRoute,
        private _episodeOvalsServiceProxy: EpisodeOvalsServiceProxy,
    ) {
        super(injector);
        this.episodeOvalId = Number(this.route.snapshot.paramMap.get('id'));
    }

    private readonly _filesSubject = new BehaviorSubject<OvalFilesDto>(undefined);
    readonly _episodeOvalFiles$ = this._filesSubject.asObservable().pipe(
        switchMap(() => this._episodeOvalsServiceProxy.getEpisodeOvalFiles(this.episodeOvalId)),
        shareReplay(1)
    );

    readonly _filesWithLevel$ = this._episodeOvalFiles$.pipe(
        map((ovalFiles) => ovalFiles.files),
    );

    readonly _ovalName$ = this._episodeOvalFiles$.pipe(
        map((ovalFiles) => ovalFiles.ovalName)
    );

    readonly _determineTemplate$ = this._episodeOvalFiles$.pipe(
        tap((ovalFiles) => {
            this.determineTemplate(ovalFiles.ovalTemplate)
        }),
    );

    readonly _episodeName$ = this._episodeOvalFiles$.pipe(
        map((ovalFiles) => ovalFiles.episodeTitle)
    );

    private readonly _urlSubject = new BehaviorSubject<string>(undefined);
    readonly _url$ = this._urlSubject.asObservable().pipe(
        map((fileGuid) => `${AppConsts.remoteServiceBaseUrl}/File/GetBinaryFile?id=${fileGuid}`),
        tap((url) => {
            window.open(
                url,
                '_blank'
            );
        }
        ));

    openFile(fileGuid: string): void {
        this._urlSubject.next(fileGuid);
        this._url$.pipe(
            take(1),
        ).subscribe();
    }

    ngOnInit(): void {
        this._determineTemplate$.subscribe();
        this._filesWithLevel$.subscribe();
    }

    determineTemplate(key: number) {
        switch (key) {
            case 2:
                this.color = "#FCE9E9";
                this.selectedTemplate = 1;
                break;
            case 3:
                this.color = "#FCE9FC";
                this.selectedTemplate = 2;
                break;
            case 4:
                this.color = "#EBE9FC";
                this.selectedTemplate = 3;
                break;
            case 5:
                this.color = "#E9FBFC";
                this.selectedTemplate = 4;
                break;
            case 6:
                this.color = "#EAFCE9";
                this.selectedTemplate = 5;
                break;
            case 7:
                this.color = "#FCF8E9";
                this.selectedTemplate = 6;
                break;
            default:
                this.color = "";
                this.selectedTemplate = 7;
                break;
        }
    }
}



